const __WEBPACK_NAMESPACE_OBJECT__ = require("@fortawesome/react-fontawesome");